export default "__VITE_ASSET__hOc0VABz__"